module.exports = __webpack_public_path__ + "static/media/2020-gz.5fb089dd.jpg";